interface Question {
	id: string;
	question: string;
	category?: string; // Renamed from department for frontend consistency
}
export const getDefaultQuestions = (): Question[] => {
	return [
		// Sprint Planning questions - 20%
		{
			id: "q1",
			question: "Did the Product Owner approve the Sprint Scope?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q2",
			question:
				"Did the Scrum Master prioritize the requirements based on client needs and discuss with product owner?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q3",
			question:
				"Did the Scrum Master verify the tasks entered by Dev and QA teams?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q4",
			question: "Did the client approve the commercials?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q5",
			question: "Did the client share requirements via mail or Jira?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q6",
			question:
				"Did the team sign off on all user stories before Sprint started?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q7",
			question:
				"Did user stories include main requirements, implementation, and impact?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q8",
			question:
				"Was a requirement discussion meeting held with the Scrum team?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q9",
			question: "Were only approved user stories included in the Sprint scope?",
			category: "cat-1", // Renamed from department
		},
		{
			id: "q10",
			question:
				"Were requirements converted into detailed user stories in Jira?",
			category: "cat-1", // Renamed from department
		},

		// Development & Testing questions - 70%
		{
			id: "q11",
			question: "Did QA conduct retesting and regression testing?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q12",
			question: "Did QA provide signoff once critical issues were fixed?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q13",
			question: "Did QA team start testing post-acceptance test?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q14",
			question: "Did QA team start writing test cases based on user stories?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q15",
			question:
				"Did the Dev team start development based on tasks and design plan?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q16",
			question: "Did the Dev team fix bugs and redeploy in QA environment?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q17",
			question: "Did the Dev team update the status of bugs post-deployment?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q18",
			question: "Was code review conducted and code rectified?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q19",
			question: "Was time spent on development tracked in Jira?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q20",
			question: "Were all tasks linked with user stories?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q21",
			question: "Were bugs assigned to the Dev team?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q22",
			question: "Were bugs entered in Jira with proper priority?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q23",
			question: "Were bugs linked with user stories?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q24",
			question:
				"Were some issues parked with PO's permission due to time constraints?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q25",
			question: "Were sub-tasks created and mapped appropriately?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q26",
			question: "Were tasks created for each user story in Jira?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q27",
			question: "Were test cases linked to user stories in Jira?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q28",
			question: "Were test cases reviewed and rectified as per feedback?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q29",
			question: "Were unit test cases created and executed by the Dev team?",
			category: "cat-2", // Renamed from department
		},
		{
			id: "q30",
			question: "Were user stories linked to the Sprint in Jira?",
			category: "cat-2", // Renamed from department
		},

		// Deployment questions - 9%
		{
			id: "q31",
			question: "Did the Dev Lead confirm the backup?",
			category: "cat-3", // Renamed from department
		},
		{
			id: "q32",
			question: "Was a backup of the current system taken before deployment?",
			category: "cat-3", // Renamed from department
		},
		{
			id: "q33",
			question: "Was a release note prepared and sent to the client?",
			category: "cat-3", // Renamed from department
		},
		{
			id: "q34",
			question: "Was deployment done in QA environment?",
			category: "cat-3", // Renamed from department
		},
		{
			id: "q35",
			question: "Was the release deployed on UAT for client's approval?",
			category: "cat-3", // Renamed from department
		},
		{
			id: "q36",
			question:
				"Was the release deployed on the Prod environment post client signoff?",
			category: "cat-3", // Renamed from department
		},
		{
			id: "q37",
			question: "Was the rollback script prepared for the database?",
			category: "cat-3", // Renamed from department
		},
		{
			id: "q38",
			question: "Was the release tracker maintained?",
			category: "cat-3", // Renamed from department
		},

		// Review & Retrospective questions - 1%
		{
			id: "q39",
			question: "Was a retrospective meeting held and tracked in Confluence?",
			category: "cat-4", // Renamed from department
		},
		{
			id: "q40",
			question: "Was a review activity added in Jira?",
			category: "cat-4", // Renamed from department
		},
		{
			id: "q41",
			question: "Was a review of the release process conducted?",
			category: "cat-4", // Renamed from department
		},
		{
			id: "q42",
			question:
				"Was the Sprint's success or failure decided in the retrospective meeting?",
			category: "cat-4", // Renamed from department
		},
	];
};

export const titleCase = (str: any) => {
	if (str == null) return ""; // Handle null or undefined
	str = str.toString(); // Ensure str is a string
	str = str.replaceAll("_", " "); // Replace underscores with spaces
	return str.toLowerCase().replace(/\b(\w)/g, (s: any) => s.toUpperCase());
};